import styled, { css } from "styled-components";
import {
  Popover as PopoverPrimitive,
  Menu as MenuPrimitive,
  MenuItem as MenuItemPrimitive,
} from "react-aria-components";
import { useDesignTokens } from "@boi/react-design-tokens";

import { useScrollShadowMixin } from "../ScrollShadow";

export const Popover = styled(PopoverPrimitive)`
  ${() => {
    const {
      tokens: {
        menu,
        scrollBar: { thumbColor, trackColor },
      },
    } = useDesignTokens();

    return css`
      display: grid;
      grid-template-rows: 1fr;
      width: max-content;
      max-width: ${menu.maxWidth};
      border-radius: ${menu.radius};
      border-width: ${menu.stroke.width};
      border-style: ${menu.stroke.style};
      border-color: ${menu.stroke.color};
      box-shadow: 0px 2px 2px ${menu.shadow.outer.color};
      background: ${menu.backgroundColor.base};
      scrollbar-color: ${thumbColor} ${trackColor};
      z-index: ${menu.zIndex};
      overflow: hidden;
    `;
  }}
`;

export const Menu = styled(MenuPrimitive)`
  ${() => {
    const scrollShadowMixin = useScrollShadowMixin();

    return css`
      outline: none;
      overflow-y: auto;

      ${scrollShadowMixin}
    `;
  }}
`;

export const MenuItem = styled(MenuItemPrimitive)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { menu } = tokens;

    return css`
      display: grid;
      min-height: ${menu.option.minHeight};
      padding: ${menu.option.padding};
      background: ${menu.option.backgroundColor.base};
      border-bottom-width: ${menu.separator.width};
      border-bottom-style: ${menu.separator.style};
      border-bottom-color: ${menu.separator.color};
      cursor: pointer;
      outline: none;

      &:last-of-type {
        border-bottom-color: transparent;
      }
    `;
  }}
`;

export const Content = styled.div`
  ${() => {
    const { tokens } = useDesignTokens();
    const { menu } = tokens;

    return css`
      display: grid;
      align-items: center;
      color: ${menu.option.inner.color.base};
      border-radius: ${menu.option.inner.radius};
      background: ${menu.option.inner.backgroundColor.base};
      outline-width: ${menu.option.inner.stroke.width};
      outline-style: ${menu.option.inner.stroke.style};
      outline-color: ${menu.option.inner.stroke.color.base};
      outline-offset: ${menu.option.inner.stroke.offset};
      overflow: hidden;

      ${MenuItem}[data-hovered] &,
      ${MenuItem}[data-focus-visible] & {
        background: ${menu.option.inner.backgroundColor.hover};
        outline-color: ${menu.option.inner.stroke.color.hover};
      }

      ${MenuItem}[data-pressed] & {
        background: ${menu.option.inner.backgroundColor.active};
        outline-color: ${menu.option.inner.stroke.color.active};
      }
    `;
  }}
`;
